"use client";

import React from "react";
import { HXIcon, ImageKit, Typography } from "@aph/ui-lib-humanx";
import { CountSectionInterface } from "@/components/SpecialistCareTeamWeb/SpecialistCareTeamWebInterface";
import { CareTeamComponent, CareTeamInfoItem } from "@/components/PageHome/api/interface";
import styles from "./SpecialistCareTeamWeb.module.scss";

const CountSection: React.FC<CountSectionInterface> = (props) => {
  const { count, bottomText } = props;

  return (
    <Typography component="p" className={styles.list}>
      <span className={styles.numerTxt}>{count}</span>
      {bottomText}
    </Typography>
  );
};

interface SpecialistCareTeamWebProps {
  data: CareTeamComponent;
}

const SpecialistCareTeamWeb: React.FC<SpecialistCareTeamWebProps> = ({ data }) => {
  const { Title, NumberText, Icon, Image } = data;

  return (
    <div className={`${styles.root} spacingBetweenSections `}>
      <div className={`container ${styles.topSection}`}>
        <div className={styles.leftSection}>
          {!!Title && (
            <Typography component="h2" className={styles.title}>
              <span dangerouslySetInnerHTML={{ __html: Title }} />
            </Typography>
          )}
          {!!NumberText.length && (
            <div className={styles.extraInfoRoot}>
              {NumberText.map(({ Number, Text, id }: CareTeamInfoItem) => (
                <CountSection key={id} count={Number} bottomText={Text} />
              ))}
            </div>
          )}
        </div>
        <div className={styles.imgRoot}>
          <ImageKit
            src={Image?.data?.attributes?.url}
            alt="banner Image"
            height={322}
            width={269}
            className={styles.imgBx}
          />
        </div>
        <div className={styles.logoSection}>
          <ImageKit src={Icon?.data?.attributes?.url} alt="logo" height={100} width={100} className={styles.logo} />
          <div className={styles.logoBg}>
            <HXIcon backgroundColor="#EBEFFF" iconPosition="topLeft" size="50x50" />
            <HXIcon backgroundColor="#E5EAFF" iconPosition="topRight" size="50x50" />
            <HXIcon backgroundColor="#E5EAFF" iconPosition="bottomLeft" size="50x50" />
            <HXIcon backgroundColor="#DBE2FF" iconPosition="bottomRight" size="50x50" />
          </div>
        </div>
      </div>
      {/* background */}
      <div className={styles.bg}>
        <div className={styles.style1}>
          <HXIcon iconPosition="topRight" backgroundColor="#EBEFFF" size="50x50" />
          <HXIcon iconPosition="topRight" backgroundColor="transparent" size="50x50" />
          <HXIcon iconPosition="bottomRight" backgroundColor="#E5EAFF" size="50x50" />
          <HXIcon iconPosition="topRight" backgroundColor="transparent" size="50x50" />
          <HXIcon iconPosition="topLeft" backgroundColor="#EBEFFF" size="50x50" />
          <HXIcon iconPosition="topRight" backgroundColor="#E5EAFF" size="50x50" />
        </div>
      </div>
    </div>
  );
};

export default SpecialistCareTeamWeb;
